import { ElectronicAccountTypeT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { useZodForm } from '@/shared/lib/forms';

import { bankingDetailsFormSchema, type BankingDetailsFormValues } from './banking-details-schema';

const DEFAULT_VALUES: BankingDetailsFormValues = {
  bankingDetails: {
    accountHolderName: '',
    routingNumber: '',
    accountNumber: '',
    accountType: ElectronicAccountTypeT.personalChecking,
  },
};

export function useBankingDetailsForm() {
  const { form, validateDraft } = useZodForm<BankingDetailsFormValues>({
    schema: bankingDetailsFormSchema,
    defaultValues: DEFAULT_VALUES,
  });

  return { form, validateDraft };
}
